import { useMsal } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { useEffect, useLayoutEffect, useRef, useState } from 'react';
import { useGoogleLogin } from '@react-oauth/google';
import { Modal } from 'antd';
import { fetchAuthenticate_Users } from './redux/slices/counter';
import { useDispatch, useSelector } from 'react-redux';
import LogIn from "./setup/login";
import RouteComponent from './setup/route.component';

const Login = (props) => {
  const { instance } = useMsal();

  const initialRender = useRef(true);

  useEffect(() => {
    if (initialRender.current) {
      initialRender.current = false;
      return;
    }

    if (props.isLoggedIn === false && props.userInfo != null) {
      props.setIsModalOpen(true);
    }
  }, [props.isLoggedIn, props.userInfo]);

  const handleAzureLogin = async () => {
    try {
      const loginResponse = await instance.loginPopup({
        scopes: ["User.Read"]
      });
      const account = instance.getActiveAccount() || loginResponse.account;
      if (account) {
        const user = {
          email: account.username,
          name: account.name
        };
        sessionStorage.setItem("userInfo", JSON.stringify(user));
        props.setUserData(user);
      }
    } catch (error) {
      console.error("Azure Login Failed", error);
    }
  };

  return (
    <>
      <LogIn azureLogin={handleAzureLogin} />
      <Modal title="Alert Information" open={props.isModalOpen} onCancel={() => props.setIsModalOpen(false)} footer={null}>
        <p>Please contact your administrator for access to the dashboard...</p>
      </Modal>
    </>
  );
};

const MainContent = () => {

  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(fetchAuthenticate_Users({
      "elasticQueryName": "Userlogin",
      "filters": [],
      "dynamicColumns": [],
    }));
  }, []);
  const Authenticate_Usersdata = useSelector(state => state.netsales.Authenticate_Users);
  const Authenticate_UsersdataLoading = useSelector(state => state.netsales.Authenticate_Usersloading);
  const [userData, setUserData] = useState({});
  const [userInfo, setUserInfo] = useState(JSON.parse(sessionStorage.getItem("userInfo")));
  const [isModalOpen, setIsModalOpen] = useState(false);
  let userEmail = userInfo && userInfo.email;


  const isLoggedIn = [...Authenticate_Usersdata]?.some(contact => contact.USERID === userEmail);

  const hasCheckedAuth = !Authenticate_UsersdataLoading && Authenticate_Usersdata.length > 0;


  useLayoutEffect(() => {
    setUserInfo(JSON.parse(sessionStorage.getItem("userInfo")));
  }, [userData]);

  useEffect(() => {
    if (hasCheckedAuth && userInfo && !isLoggedIn) {
      sessionStorage.clear();
      setUserInfo(null);


    }
  }, [hasCheckedAuth, isLoggedIn, userInfo]);


  return (
    <div>
      {/* {isLoggedIn ? <>
        <RouteComponent setUserData={setUserData} />
      </>
        : Authenticate_UsersdataLoading ? null : <Login
          setUserData={setUserData}
          isModalOpen={isModalOpen}
          setIsModalOpen={setIsModalOpen}
          isLoggedIn={isLoggedIn}
          userInfo={userInfo} />} */}
      <RouteComponent setUserData={setUserData} />
    </div>
  );
};

export function App() {

  return (
    <MainContent />
  )
}

export default App;
